import { Component, forwardRef, OnInit } from '@angular/core';
import { UntypedFormArray, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { Subject } from 'rxjs';
import { EaRentFormPersonalUseService } from './ea-rent-form-personal-use.service';
import {
  fiscalLawOptionsMeublee,
  fiscalLawOptionsNue,
} from './personal-use-fiscal-law-options';

@Component({
  selector: 'ea-rent-form-personal-use',
  templateUrl: './ea-rent-form-personal-use.component.html',
  styleUrls: ['./ea-rent-form-personal-use.component.scss'],
  providers: [
    {
      provide: PrFormAbstract,
      useExisting: forwardRef(() => EaRentFormPersonalUseComponent),
    },
  ],
  standalone: false,
})
export class EaRentFormPersonalUseComponent
  extends PrFormAbstract
  implements OnInit
{
  periodicityTypes = [];

  rentTypeOptions = [
    { id: 'NUE', value: 'Location nue' },
    { id: 'MEUBLEE', value: 'Location meublée' },
  ];
  fiscalLawOptionsNue = fiscalLawOptionsNue;

  fiscalLawOptionsMeublee = fiscalLawOptionsMeublee;

  constructor(
    protected formConstructor: PrFormConstructor,
    public rentFormService: EaRentFormPersonalUseService,
    protected refDao: ReferenceDao,
  ) {
    super(formConstructor);
    this.rentFormService.generateSubject.subscribe(
      formGroup => (this.form = formGroup),
    );
  }

  ngOnInit() {
    if (!this.form.controls) this.initForm(this.entity);
    this.refDao.getPeriodicityType().subscribe(periodicityTypes => {
      this.periodicityTypes = periodicityTypes;
    });
  }

  getFiscalLawOptions(index: number) {
    const rentType = this.rents.at(index).get('rentType')?.value;
    return rentType === 'MEUBLEE'
      ? this.fiscalLawOptionsMeublee
      : this.fiscalLawOptionsNue;
  }

  onRentTypeChange(index: number) {
    const rentType = this.rents.at(index).get('rentType')?.value;
    const defaultFiscalLaw =
      rentType === 'MEUBLEE' ? 'MICRO_BIC' : 'MICRO_FONCIER';
    this.rents.at(index).get('rentFiscalLaw')?.setValue(defaultFiscalLaw);
  }

  onPartialRentChange(index: number) {
    const rentGroup = this.rents.at(index);
    const isPartialRent = rentGroup.get('isPartialRent')?.value;
    const endDateControl = rentGroup.get('endDate');
    const rentedAreaControl = rentGroup.get('rentedArea');

    if (isPartialRent) {
      rentedAreaControl?.setValidators([
        Validators.required,
        Validators.min(1),
      ]);
      endDateControl?.clearValidators();
      endDateControl?.updateValueAndValidity();
    } else {
      rentedAreaControl?.clearValidators();
      rentedAreaControl?.setValue(null);
      endDateControl?.setValidators([Validators.required]);
    }
    rentedAreaControl?.updateValueAndValidity();
    endDateControl?.updateValueAndValidity();
  }

  getPropertyAreaSize(): number | null {
    return (
      this.entity?.property?.areaSize ||
      this.entity?.realestate?.property?.areaSize ||
      null
    );
  }

  isPartialRent(index: number): boolean {
    return this.rents.at(index).get('isPartialRent')?.value === true;
  }

  onDelete(index: number) {
    this.rentFormService.removeModel(
      index,
      this.rents,
      this.entity.userId,
      this.entity.typeUrl,
      this.entity.id,
    );
    this.entity.rents?.splice(index, 1);
  }

  get rents(): UntypedFormArray {
    return this.form.get('rents') as UntypedFormArray;
  }

  public generate(): any {
    return this.rentFormService.generate(this.entity);
  }

  public extract() {
    return this.rentFormService.extract(this.form);
  }

  onSubmit() {}
  doneSubject = new Subject<void>();
}
